import "./About.css";
import Scroll from "./ScrollBox/Scroll";

export default function About() {
    return (
        <section className="AboutSection" id="About">
            <h1 className="AboutHeader">About Me</h1>
            <Scroll />
            <div className="BlueBall"></div>
        </section>
    )
}